import { createFileRoute } from '@tanstack/react-router';
import { ClerkScope } from '../../auth/ClerkScope';
import { RequireAuth } from '../../auth/RequireAuth';
import { DashboardLayout } from '../../pages/dashboard/DashboardLayout';

// The signed-in dashboard is client-only (no SEO value) - `ssr: false` skips
// server rendering, and the Clerk-based RequireAuth guard runs on the client,
// preserving the old RequireAuth behavior from routes.tsx.
//
// `ClerkScope` mounts the provider here rather than at the root, so marketing
// pages ship no Clerk script at all.
export const Route = createFileRoute('/dashboard')({
  ssr: false,
  component: DashboardRoute,
});

function DashboardRoute() {
  return (
    <ClerkScope>
      <RequireAuth>
        <DashboardLayout />
      </RequireAuth>
    </ClerkScope>
  );
}
